import 'src/styles/components/hr/hr.scss'

const Hr = () => (
    <div className="hr"></div>
)

export default Hr